import React from 'react';
import { Box, keyframes } from '@mui/material';
import { CircularProgress } from '@mui/material';

interface UILoadingOverlayProps {
  variant?: 'wave' | 'spinner';
  customHeight?: string;
  borderRadius?: string;
}

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const UILoadingOverlay: React.FC<UILoadingOverlayProps> = ({
  variant = 'wave',
  customHeight = '95%',
  borderRadius = '8px'
}) => {
  if (variant === 'spinner') {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          backdropFilter: "blur(8px)",
          borderRadius: '16px',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CircularProgress size={32} sx={{ color: '#F98207' }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(16, 37, 84, 0.2)',
        backdropFilter: "blur(1px)",
        borderRadius: '16px',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px'
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: customHeight,
          borderRadius,
          background: `linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.08) 25%,
            rgba(0, 0, 0, 0.12) 37%,
            rgba(0, 0, 0, 0.08) 63%
          )`,
          backgroundSize: '200% 100%',
          animation: `${shimmer} 2.8s infinite linear`,
        }}
      />
    </Box>
  );
};

export default UILoadingOverlay;